
export const MINIMUM_FILTER_NUM_TO_LOAD = 1;

export const svrTypes = {
    NORMAL_SVR: 0,
    MULTI_DAY_SVR: 1
};
